// Vendor
import { EventEmitter } from '@angular/core';
import { DASHBOARD, SAVED_SCORE, TALKING_POINT, WATCHLIST } from 'ConverterApp/constants';
import { LEGACY_DATA_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
// Services
import { ConverterService } from 'ConverterApp/services/converter.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { ConvertModalComponent } from 'ConverterApp/features/convert-modal/convert-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "ConverterApp/services/converter.service";
import * as i3 from "../convert-modal/convert-modal.component";
export class LegacyAssetConversionCheckerComponent {
    constructor(featureService, converterService) {
        this.featureService = featureService;
        this.converterService = converterService;
        /**
         * For certain assets we want to disable in-place conversion
         */
        this.copyOnly = false;
        // Component outputs
        /**
         * Event emitted when the asset is checked.
         *
         * The argument indicates if the asset has been updated or not.
         */
        this.assetChecked = new EventEmitter();
        /**
         * Event emitted when a generic-compliant copy of the asset has been created.
         *
         * The argument is the ID of the new asset.
         */
        this.assetCopied = new EventEmitter();
        /**
         * Event emitted when no action has been taken.
         */
        this.canceled = new EventEmitter();
        // Component data
        this._assetId = '';
        this.assetDiff = null;
        this.error = undefined;
        // Event handlers
        this.handleConversion = (id) => {
            if (id === this.assetId.toString()) {
                this.reset();
                this.assetChecked.emit(true);
            }
            else
                this.assetCopied.emit(id);
        };
        this.handleCancellation = () => {
            this.canceled.emit();
        };
        // Logic
        this.reset = () => {
            this.assetDiff = null;
            this.error = undefined;
        };
        this.reloadDiff = () => {
            return this.converterService.getDiff(this.assetType, this.assetId).subscribe({
                next: (response) => {
                    this.assetDiff = response.body.diff;
                },
                error: (response) => {
                    this.error = response.error.error;
                },
            });
        };
        this.check = () => {
            const noDiff = this.assetDiff === null || Object.keys(this.assetDiff).length === 0;
            const noError = this.error === undefined;
            if (noDiff && noError) {
                this.assetChecked.emit(false);
            }
            else {
                this.convertModal.openModal();
            }
        };
        // Public methods
        this.reloadDiffAndCheck = (assetId) => {
            if (this.hasLegacyData || !assetId) {
                this.reset();
                this.assetChecked.emit(false);
            }
            else if (assetId === this.assetId) {
                this.check();
            }
            else {
                this._assetId = assetId;
                this.reset();
                this.reloadDiff().add(this.check);
            }
        };
        this.hasLegacyData = featureService.userHasFeatures([LEGACY_DATA_FEATURE]);
    }
    // Interface implementations
    ngOnInit() {
        if (this.assetType && this.assetId)
            this.reloadDiff();
    }
    // Properties
    get assetRequiresAction() {
        if (this.assetType === DASHBOARD)
            return false; // Dashboards go to Manage page if action is canceled
        const assetsWithModalEditor = [SAVED_SCORE, TALKING_POINT, WATCHLIST];
        return !assetsWithModalEditor.includes(this.assetType);
    }
    get assetId() {
        return this._assetId;
    }
}
LegacyAssetConversionCheckerComponent.ɵfac = function LegacyAssetConversionCheckerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LegacyAssetConversionCheckerComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.ConverterService)); };
LegacyAssetConversionCheckerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LegacyAssetConversionCheckerComponent, selectors: [["ycn-legacy-asset-conversion-checker"]], viewQuery: function LegacyAssetConversionCheckerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConvertModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.convertModal = _t.first);
    } }, inputs: { assetType: "assetType", copyOnly: "copyOnly" }, outputs: { assetChecked: "assetChecked", assetCopied: "assetCopied", canceled: "canceled" }, standalone: false, decls: 1, vars: 6, consts: [[3, "converted", "canceled", "assetId", "assetType", "assetDiff", "error", "requiresAction", "copyOnly"]], template: function LegacyAssetConversionCheckerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-convert-modal", 0);
        i0.ɵɵlistener("converted", function LegacyAssetConversionCheckerComponent_Template_ycn_convert_modal_converted_0_listener($event) { return ctx.handleConversion($event); })("canceled", function LegacyAssetConversionCheckerComponent_Template_ycn_convert_modal_canceled_0_listener() { return ctx.handleCancellation(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("assetId", ctx.assetId)("assetType", ctx.assetType)("assetDiff", ctx.assetDiff)("error", ctx.error)("requiresAction", ctx.assetRequiresAction)("copyOnly", ctx.copyOnly);
    } }, dependencies: [i3.ConvertModalComponent], encapsulation: 2 });
